class CurrentUserService {

    constructor() {
        this.build();
    }

    build() {
        const authInfoString = localStorage.getItem("user");
        const authInfo = JSON.parse(authInfoString);
        this.user = authInfo?.utilisateur; 
    }
    
    get() {
        return this.user;
    }

    getType() {
        return this.user?.typeUtilisateur;
    }
}

export default new CurrentUserService();